import { useCallback, useMemo, useState } from "react";
import { httpsCallable } from "firebase/functions";
import { functions } from "@poseidon/firebase/firebase";
import { useErrorMessage } from "@poseidon/ui/app/toasts/useErrorMessage";
import { useToastMessage } from "@poseidon/ui/app/toasts/useToastMessage";

/** Adds a second sailor as a party to an agreement via the
 * `addAgreementSailor` callable. Resolves true on success. */
export const useAddAgreementSailor = () => {
  const executeCallable = useMemo(
    () => httpsCallable(functions, "addAgreementSailor"),
    []
  );
  const { setError } = useErrorMessage();
  const { setToast } = useToastMessage();
  const [saving, setSaving] = useState(false);

  const addAgreementSailor = useCallback(
    async ({ agreementId, sailorId }) => {
      setSaving(true);
      try {
        const result = await executeCallable({ agreementId, sailorId });
        if (!result?.data?.success) {
          throw new Error("Failed to add the sailor to the agreement");
        }
        setToast("Joint sailor added to agreement");
        return true;
      } catch (error) {
        setError(error.message ?? "Failed to add the sailor to the agreement");
        return false;
      } finally {
        setSaving(false);
      }
    },
    [executeCallable, setError, setToast]
  );

  return { addAgreementSailor, saving };
};
